import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { localizeDate } from '../../../utils/vuex';
import ApiService from '../../../services/apiService';
import deviceMixin from './deviceMixin';
export default {
  name: 'IsAssetMgmtEdit',
  mixins: [deviceMixin],
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      formValid: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this.operationalStatus[status],
          value: status
        };
      });
    },
    cardButtons: function cardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  }),
  methods: {
    localizeDate: localizeDate,
    setTags: function setTags(a) {
      this.twinObject.data.tags = a.tags;
    },
    saveAsset: function saveAsset() {
      var _this2 = this;

      // polygon is set server-side and adapted to the current coordinate
      if (this.twinObject.data.polygonMode === 'auto') {
        this.twinObject.polygon = null;
      }

      this.twinObject.data.assetManagement.deviceIds = this.deviceData.map(function (d) {
        return d.deviceId;
      });
      ApiService.digitalTwinUpdate(this, this.twinObject).then(function (result) {
        _this2.twinObject = result;

        _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');

        _this2.$emit('close', result);

        return _this2.twinObject;
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(function () {
        _this2.$store.state.app.loading = false;
      });
    }
  }
};